import * as React from 'react';

import {AlertBox} from 'shells/alert-box/alert-box';
import {FormWrapperWithButtons} from 'shells/form/form-wrapper-with-buttons';
// @ts-expect-error - imported from .js/.jsx file
import {ContactAssigneeIcon} from 'shells/icon/svg/contact-assignee-icon';
import {LeadIcon} from 'shells/icon/svg/lead-icon';
import type {ListOptionWithIcon} from 'shells/select-option-components/option-with-icon';

import type {NotifiableAliasType} from 'nutshell-graphql-types';

import {GraphQLSelectUsers} from '../../../../core/select/graphql-select-users';

type Props = {
    errorMessage?: string;
    onCancel: () => void;
    onSetNotification: (userIds: string[], assigneeValues: NotifiableAliasType[]) => void;
    setIsEditing: (arg1: boolean) => void;
    notifiableUserIds: string[];
    notifiableAssigneeTypes: NotifiableAliasType[];
};

export function NotificationConfigModal(props: Props) {
    const [selectedUserIds, setSelectedUserIds] = React.useState<string[]>(props.notifiableUserIds);
    const [selectedAssigneeValues, setSelectedAssigneeValues] = React.useState<
        NotifiableAliasType[]
    >(props.notifiableAssigneeTypes);
    const [isSaving, setIsSaving] = React.useState<boolean>(false);

    const selectedIds = selectedUserIds.concat(selectedAssigneeValues);

    const handleSaving = () => {
        setIsSaving(true);
        setTimeout(() => {
            setIsSaving(false);
        }, 1000);
    };

    return (
        <AlertBox onClose={props.onCancel}>
            <FormWrapperWithButtons
                title='Notify someone when link is clicked'
                subtitle='Select one or more Nutshell users to receive a notification whenever this link is clicked.'
                isSaving={isSaving}
                onCancel={props.onCancel}
                onSaveClick={() => {
                    props.onSetNotification(selectedUserIds, selectedAssigneeValues);
                    handleSaving();
                }}
                onClearSaveComplete={() => props.setIsEditing(false)}
                buttonText='Save'
                errorSaving={Boolean(props.errorMessage)}
                resetOnSaveComplete={true}
            >
                <div className='full-width'>
                    <GraphQLSelectUsers
                        selectedId=''
                        selectedIds={selectedIds}
                        valueKey='value'
                        labelKey='label'
                        onChange={(selection: ListOptionWithIcon[]) => {
                            if (!selection) {
                                setSelectedUserIds([]);
                                setSelectedAssigneeValues([]);

                                return;
                            }

                            const selectedValues = selection.map((user) => user.value);
                            const userIds = selectedValues.filter(
                                (value) =>
                                    value !== 'CONTACT_ASSIGNEE' &&
                                    value !== 'RELATED_LEAD_ASSIGNEE'
                            );
                            const assigneeValues = selectedValues.filter(
                                (value) =>
                                    value === 'CONTACT_ASSIGNEE' ||
                                    value === 'RELATED_LEAD_ASSIGNEE'
                            );

                            setSelectedUserIds(userIds);
                            setSelectedAssigneeValues(assigneeValues);
                        }}
                        onClearValue={() => {
                            setSelectedUserIds([]);
                            setSelectedAssigneeValues([]);
                        }}
                        staticOptions={[
                            {
                                label: 'Contact assignee',
                                value: 'CONTACT_ASSIGNEE',
                                icon: ContactAssigneeIcon,
                            },
                            {
                                label: 'Related lead assignee',
                                value: 'RELATED_LEAD_ASSIGNEE',
                                icon: LeadIcon,
                            },
                        ]}
                    />
                </div>
            </FormWrapperWithButtons>
        </AlertBox>
    );
}
